import ValidateDefaults from 'validation/ValidateDefaults';

export default class ValidatePassword extends ValidateDefaults {
    constructor(obj) {
        super(obj);
        this.message = obj.message ? obj.message : 'Required';
        this.on = ['blur'];
    }

    // TODO
    validate(str) {
        let pw = str.trim();

        if (pw.length < 6) {
            this.message = 'Password is too short.';
            return false;
        }

        if (pw.length > 30) {
            this.message = 'Password is too long.';
            return false;
        }

        return pw.length > 0;
    }
}
